import React from 'react'
import { withRouter } from 'react-router'
import styles from './TrialConfirmationPage.scss'
import { StandardLayout } from 'common/layouts/StandardLayout'
import { CTA } from 'common/styleguide/CTA'
import { Msg, commonCTAs } from 'lib/localization'
import { FormattedMessage as T } from 'react-intl'

export class _TrialConfirmationPage extends React.PureComponent {
  render () {
    const redirectTo = this.props.location.query.redirect_to

    return (
      <StandardLayout>
        <div className={styles.TrialLandingPage}>
          <h1><T id='TrialConfirmationPage.active' defaultMessage='Your 7 Day Trial is Active.' /></h1>
          <p>
            <T
              id='TrialConfirmationPage.thanks'
              defaultMessage='Thank you for taking our Premium account for a spin. You now have access to all of our signature features to help you plan, navigate, and share amazing rides. Take a few minutes to learn about our Premium features so you can get the most out of your subscription.' />
          </p>
          <CTA href='/help/why-go-premium'><Msg m={commonCTAs.learnMorePremium} /></CTA>
          {redirectTo && <CTA secondary to={redirectTo}><Msg m={commonCTAs.goBack} /></CTA>}
          {!redirectTo && <CTA secondary to='/'><T id='TrialConfirmationPage.goToDash' defaultMessage='Go to your Dashboard' /></CTA>}
        </div>
      </StandardLayout>
    )
  }
}

export const TrialConfirmationPage = withRouter(_TrialConfirmationPage)
